/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { Traffic } from "../../models/traffic";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface GetIotnetGatewayTraffic$Params {
  customer_id: string;
  gateway_id: string;
  start?: number | null;
  end?: number | null;
  step?: number;
  raw?: boolean;
}

export function getIotnetGatewayTraffic(
  http: HttpClient,
  rootUrl: string,
  params: GetIotnetGatewayTraffic$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Traffic>> {
  const rb = new RequestBuilder(rootUrl, getIotnetGatewayTraffic.PATH, "get");
  if (params) {
    rb.path("customer_id", params.customer_id, {});
    rb.path("gateway_id", params.gateway_id, {});
    rb.query("start", params.start, {});
    rb.query("end", params.end, {});
    rb.query("step", params.step, {});
    rb.query("raw", params.raw, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Traffic>;
    }),
  );
}

getIotnetGatewayTraffic.PATH = "/stats/customers/{customer_id}/iotnet-gateways/{gateway_id}/traffic";
